import React, { useState, ReactNode } from 'react';
import { Tabs } from 'antd';
import { Block, FlexBox } from '../layouts';

const { TabPane } = Tabs;

interface TabItem {
    key: string;
    render: React.ReactNode;
}

interface AppTabProps {
    items: TabItem[];
    children: (props: {
        activeKey: string;
        setActiveKey: React.Dispatch<React.SetStateAction<string>>;
    }) => ReactNode;
    className?: string;
}

export const AppTab = ({ items, className, children }: AppTabProps) => {
    const [activeKey, setActiveKey] = useState<string>(items[0]?.key || '');

    return (
        <FlexBox direction='column' >
            <Tabs activeKey={activeKey} onChange={setActiveKey} className={className}>
                {items.map((item) => (
                    <TabPane tab={item.render} key={item.key} />
                ))}
            </Tabs>
            <Block>{children({ activeKey, setActiveKey })}</Block>
        </FlexBox>
    );
};
